import * as React from 'react';
import { ItemFieldProps } from './types';
import { BooleanField } from './booleanField';
import { TaskGroup } from '../../../../enums/TaskGroup';

export const CriticalField = (f: ItemFieldProps) => {
  const group = f.group;
  if (group?.props?.isMyTaskGroup) {
    if (
      ![
        TaskGroup.OutlineReview,
        TaskGroup.ManagementSignoff,
        TaskGroup.AuthorReview
      ].includes(group.props.name)
    ) {
      return null;
    }
  }
  return <BooleanField {...f} />;
};
